<div #apSelectElement>
  <ng-content></ng-content>
</div>
